import bookingCollectionOperations from './bookingCollectionOperations';
import resourcesOperations from './resourcesOperations';
import alternativesOperations from './alternativesOperations';

export default {
  ...bookingCollectionOperations,
  ...resourcesOperations,
  ...alternativesOperations
};
